




































































import {Component, PropSync} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {SelectWings, ToggleWings, InputWings} from "wings-ui-components";

import {MessageCategoryFilter} from '@/store/settings/message_categories/types';
import BaseFilter from "@/components/Filter/BaseFilter";
import {notifyError} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class MessageCategoriesFilter extends BaseFilter<MessageCategoryFilter> {

  @PropSync("show") is_show!: boolean;

  @Action("getMessageCategories") actionGetMessageCategories: any;
  @Action("getAllowedTransports") actionAllowedTransports: any;
  @Action("exportMessageTypes") actionExport: any;
  @Action("getTransports") actionGetTransports: any;

  @Getter("allowedTransports") allowedTransportsList: any;
  @Getter("transports") transportsList: any;

  defaultFilter(): MessageCategoryFilter {
    return {
      name: undefined,
      transport: undefined,
      is_default: undefined
    };
  }

  created() {
    this.actionGetTransports();
    this.actionAllowedTransports();
    this.filtered();
  }

  getTransportName(transport_id: any): any {
    if (this.transportsList) {
      return this.transportsList.find((t: any) => t.id === transport_id)?.name;
    }
  }

  export() {
    this.actionExport(this.filter)
        .catch((error: any) => notifyError(error));
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message category",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetMessageCategories(this.filter);
      await this.actionLog(this.logObject);
    } catch (e){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
